var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "room-item", class: { over: _vm.room.state == 1 } },
    [
      _c("div", { staticClass: "roll-header flex flex-center-2" }, [
        _c("div", { staticClass: "room-name flex flex-ver" }, [
          _c(
            "div",
            {
              staticClass: "btn-tit",
              class: { official: _vm.room.isOfficial },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.room.creatorId > 0
                      ? "自建"
                      : _vm.room.isOfficial
                      ? "官方"
                      : "主播"
                  ) +
                  " "
              ),
            ]
          ),
          _vm._v(" " + _vm._s(_vm.room.name) + " "),
        ]),
        _c("div", { staticClass: "join-count" }),
      ]),
      _c("div", { staticClass: "room-body flex flex-ais flex-center-2" }, [
        _c(
          "div",
          {
            staticClass: "avatar-box flex flex-center-1",
            class: { official: _vm.room.isOfficial },
          },
          [
            _vm.room.avatar
              ? _c("img", { attrs: { src: _vm.$imgfilter(_vm.room.avatar) } })
              : _c("img", {
                  attrs: { src: require("@/assets/images/logo_kjcs2.png") },
                }),
            _c("c-svg", {
              staticClass: "itembg",
              attrs: {
                src: "itembg.svg",
                width: "106",
                height: "106",
                fill: "rgb(0, 0, 0,.2)",
              },
            }),
          ],
          1
        ),
        _c(
          "ul",
          { staticClass: "room-awards" },
          _vm._l(_vm.room.items, function (item, award_index) {
            return _c(
              "li",
              { key: award_index, staticClass: "flex flex-center-1" },
              [
                _c(
                  "div",
                  {
                    staticClass: "award flex flex-center-1",
                    class: "rarity_" + item.rarity,
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: item.itemPic
                          ? _vm.$imgfilter(item.itemPic)
                          : require("@/assets/images/icon/cash.png"),
                      },
                    }),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "footer flex flex-center-2" }, [
        _c("div", { staticClass: "flex flex-ver" }, [
          _c(
            "div",
            { staticClass: "price flex flex-ver" },
            [
              _c("span", [
                _vm._v(_vm._s(_vm._f("conversion")(_vm.room.totalPrice))),
              ]),
              _c("c-svg", {
                attrs: {
                  src: "bill.svg",
                  width: "12",
                  height: "12",
                  fill: "#F5B844",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "time" }, [
            _vm._v(" Ends: "),
            _c("i", [
              _vm._v(_vm._s(_vm.room.expir_time.replace(/\s{1}[^]+/, ""))),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "resolve-btn flex flex-center-2" }, [
          _c(
            "p",
            { staticClass: "resolve-btn-icon-wrap flex flex-ver" },
            [
              _vm.room.password
                ? _c("Icon", { attrs: { type: "md-lock", size: "18" } })
                : _vm._e(),
              _c("Icon", { attrs: { type: "md-add-circle", size: "18" } }),
            ],
            1
          ),
          _c("p", { staticClass: "resolve-btn-text" }, [
            _vm._v(" " + _vm._s(_vm.room.state == 1 ? "结束" : "加入")),
          ]),
          _c("div", { staticClass: "resolve-btn-block" }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }